module.exports = __webpack_public_path__ + "static/media/apple.0e27920a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/apple.svg
// module id = 110
// module chunks = 0